module.exports = __webpack_public_path__ + "static/media/imagem.cd567349.png";